import {
  ADD_PRODUCT,
  REMOVE_PRODUCT,
  LOADING_CART,
  HANDLE_ONE_PRODUCT_QUANTITY,
  CART_ERROR,
  REMOVE_ALL_PRODUCTS,
} from "../actions/types";

import { lsCartToArray } from "../../commons/functions/generalFunctions";

let cart = lsCartToArray();

const initialState = {
  cart: cart,
  loading: true,
  error: {},
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case LOADING_CART:
      return { ...state, loading: true };
    case ADD_PRODUCT:
      return { cart: payload, loading: false };
    case HANDLE_ONE_PRODUCT_QUANTITY:
      return { cart: payload, loading: false };
    case REMOVE_PRODUCT:
      let newCart = state.cart.filter(({ id }) => id !== payload);
      let string = [];
      let numberArrangements = 0;
      newCart.forEach((item) => {
        if (item.type === "arrangement") {
          numberArrangements = numberArrangements + 1;
        }
      });
      if (numberArrangements === 0) {
        newCart.forEach((item) => {
          if (item.type === "accessories") {
            newCart = newCart.filter(({ id }) => id !== item.id);
          }
        });
      }
      newCart.map((item) => {
        return string.push(JSON.stringify(item));
      });

      localStorage.setItem("cart", string.toString());
      return { cart: newCart, loading: false };
    case REMOVE_ALL_PRODUCTS:
      localStorage.removeItem("cart");
      return { ...state, cart: [] };
    case CART_ERROR:
      return {
        ...state,
        error: payload,
      };
    default:
      return state;
  }
};
